type Props = {
  onLogCall: () => void;
  onSendWhatsApp?: () => void;
};

export function QuickActionsCard({ onLogCall, onSendWhatsApp }: Props) {
  const actions = [
    { icon: "ri-phone-line", label: "Log a Call", color: "border-indigo-300 text-indigo-600 hover:bg-indigo-50", onClick: onLogCall },
    { icon: "ri-whatsapp-line", label: "Send WhatsApp", color: "border-green-300 text-green-600 hover:bg-green-50", onClick: onSendWhatsApp },
    { icon: "ri-calendar-check-line", label: "Schedule Follow-up", color: "border-amber-300 text-amber-600 hover:bg-amber-50" },
    { icon: "ri-mail-send-line", label: "Send Email", color: "border-purple-300 text-purple-600 hover:bg-purple-50" },
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-5 md:p-6">
      <h3 className="text-sm font-semibold text-gray-900 mb-4">Quick Actions</h3>
      <div className="space-y-2">
        {actions.map((action) => (
          <button
            key={action.label}
            onClick={action.onClick}
            className={`w-full flex items-center gap-3 px-4 py-2.5 rounded-lg border text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${action.color}`}
          >
            <i className={`${action.icon} text-base w-4 h-4 flex items-center justify-center`} />
            {action.label}
          </button>
        ))}
        <button className="w-full flex items-center gap-3 px-4 py-2.5 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium transition-all duration-200 whitespace-nowrap">
          <i className="ri-check-double-line text-base w-4 h-4 flex items-center justify-center" />
          Convert to Deal
        </button>
      </div>
    </div>
  );
}